<template>
  <v-dialog
    :value="loadingDialog"
    persistent
    fullscreen
    :transition="false"
  >
    <v-container fluid fill-height>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular
            indeterminate
            size="60"
            width="5"
            color="success"
            class="py-0 ma-auto"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'pageLoadingSpinner',
  computed: {
    ...mapState({
      loadingDialog: state => state.routeLoading,
    }),
  },
};
</script>
